import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchServiceRequestStatusApiCallFun, handleDownloadDocument } from '../../Global/Index';
import BeatLoader from "react-spinners/BeatLoader";
import ClipLoader from 'react-spinners/ClipLoader';
import './All Services.css'
import { useTheme } from '@mui/material';

const overridee = {
    display: "block",
    margin: "10% auto",
    marginLeft: '50%'
};

const mapservicename = {
    'Generate Welcome Kit': 'Welcome Letter',
    'Request for Disbursal': 'Request for Disbursal',
    'Insurance Certificate Copy': 'Insurance Certificate Copy',

    'Critical Illness Insurance': 'Critical illness Insurance',
    'Life Insurance': 'Life Insurance',
    'Property Insurance': 'Property Insurance',
    'Health Insurance': 'Health Insurance',


    'Repayment Schedule': 'Repayment Schedule',
    'Interest Certificate': 'Interest Certificate',
    'Statement of Accounts': 'Statement of Accounts'
}


const ServiceStatus = ({ activeservicename }) => {
    let activeloanstatus = null;
    let filteredRequest = null;
    const [data, setData] = useState(null);
    const [allservicestatus, setAllservicestatus] = useState(null);
    const theme = useTheme();
    const [showPopup, setShowPopup] = useState(false);
    const [currentDocURL, setCurrentDocURL] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [selectedServiceRequest, setSelectedServiceRequest] = useState(null);
    const ref = React.createRef();

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [ref]);

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsOpen(false);
        }
    };


    const handleViewDocument = (url) => {
        setCurrentDocURL(url);
        setShowPopup(true);
    };


    const closePopup = () => {
        setShowPopup(false);
        setCurrentDocURL('');
    };

    const fetchServiceStatusList = async () => {

        try {
            const resp = await fetchServiceRequestStatusApiCallFun();
            if (resp.response.status == "200" && resp.response.message == 'Success') {
                activeloanstatus = resp.response.data;
                setAllservicestatus(activeloanstatus);

                if (activeservicename == "E-Mandate") {
                    filteredRequest = activeloanstatus.filter(
                        item => item.requestName == "Create Mandate"
                            || item.requestName == "Revoke Mandate"
                            || item.requestName == "Update Mandate"
                            || item.requestName == "Suspend/Revoke Mandate"
                            || item.requestName == 'Cancel Mandate'
                            || item.requestName == 'Amend Mandate'
                    );
                }

                else {
                    filteredRequest = activeloanstatus.filter(
                        item => item.requestName == mapservicename[activeservicename]
                    );
                }
                setData(filteredRequest);
            } else if (resp.response.status === "500") {
                toast.error('Something went wrong. Please try again later!')
            } else if (resp.response.status === "503") {
                toast.warn(resp.response.message);
            } else if (resp.response.status == '401') {
                window.location.href = '/'
            } else if (resp.response.status == '419') {
                window.location.href = '/Session-Expired'
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }


    const handleToggleClose = (isItem, selectedItem = []) => {
        if (isItem) {
            setSelectedServiceRequest(selectedItem)
        } else {
            setSelectedServiceRequest(null);
        }
        setIsOpen(!isOpen);
    }


    const updateservicerequest = () => {
        filteredRequest = allservicestatus.filter(
            item => item.requestName == activeservicename
        );
        setData(filteredRequest);
    }


    useEffect(() => {
        if (allservicestatus === null) {
            fetchServiceStatusList();
        } else {
            updateservicerequest();
        }

    }, [activeservicename])

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [filterStatus, setFilterStatus] = useState('All'); // State to track the filter status

    if (data === null) {
        return (<ClipLoader
            color={theme.palette.maincolor.light}
            loading={true}
            cssOverride={overridee}
            size={30}
            aria-label="Loading Spinner"
            data-testid="loader"
        />)

    } else {
        const filteredRequests = data.filter(item => {
            if (filterStatus === 'Closed') {
                return item.requestStatus === 'Closed';
            }
            else if (filterStatus === 'Pending') {
                return item.requestStatus === 'Pending';
            }
            else if (filterStatus === 'In Progress') {
                return item.requestStatus === 'In Progress';
            }
            return true;
        });



        const totalPages = Math.ceil(filteredRequests.length / itemsPerPage); // total number of pages calculation logic

        // Get current items
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = filteredRequests.slice(indexOfFirstItem, indexOfLastItem);


        const handleNext = () => {
            if (currentPage < totalPages) {
                setCurrentPage(currentPage + 1);
            }
        };

        const handlePrev = () => {
            if (currentPage > 1) {
                setCurrentPage(currentPage - 1);
            }
        };
        const handleFilterChange = (status) => {
            setFilterStatus(status);
            setCurrentPage(1); // Reset to the first page when filter changes
        };


        return (
            <>
                {
                    isOpen && selectedServiceRequest && (
                        <div className="emailoutercontainer">
                            <div className="email-verification-container" ref={ref} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.main }} >
                                <div style={{ textAlign: 'right', fontSize: '3vh' }}>
                                    <button
                                        type="button"
                                        onClick={() => handleToggleClose(0)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                handleToggleClose(0);
                                            }
                                        }}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            fontSize: 'inherit',
                                            padding: '0',
                                            color: 'inherit'
                                        }}
                                        aria-label="Close"
                                    >
                                        <i className="bi bi-x-lg" />
                                    </button>
                                </div>
                                <div className="request-content">
                                    <div className="request-info">


                                    </div>
                                    <div className="right-section">
                                        <div style={{ textAlign: 'left' }}>
                                            <div><b>SR :</b> {selectedServiceRequest.caseNumber}</div>
                                        </div>
                                    </div>
                                    <p style={{ marginBottom: '.2vw' }}>
                                        <b>Comments :</b> {selectedServiceRequest.Comments}
                                    </p>
                                </div>
                            </div>
                        </div>)
                }


                <div className='service-status-container' >
                    <BeatLoader
                        color="rgb(155,57,19)"
                        loading={currentItems == null || data == null}
                        cssOverride={overridee}
                        size={10}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />


                    <div style={{ display: 'flex', width: '97%', margin: 'auto' }}>
                        <button onClick={() => handleFilterChange('All')} className={`servicerequestfilter ${filterStatus === 'All' ? 'activefilterbutton' : ''}`} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>All</button>
                        <button onClick={() => handleFilterChange('Closed')} className={`servicerequestfilter ${filterStatus === 'Closed' ? 'activefilterbutton' : ''}`} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>Closed</button>
                        <button onClick={() => handleFilterChange('Pending')} className={`servicerequestfilter ${filterStatus === 'Pending' ? 'activefilterbutton' : ''}`} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>Pending</button>
                        <button onClick={() => handleFilterChange('In Progress')} className={`servicerequestfilter ${filterStatus === 'In Progress' ? 'activefilterbutton' : ''}`} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>In Progress</button>
                    </div>
                    {currentItems?.length == 0 ? <div style={{ textAlign: 'center', marginTop: '2vh' }}>NA</div> : ''}
                    <div className="service-request-container">
                        {/* Service Request List */}
                        {currentItems?.map((item, index) => (
                            <div
                                key={index + 1}
                                className={item.requestStatus === "Closed" ? "isclosedservicerequest" : "isopenservicerequest"}
                                style={{ width: '97%', margin: 'auto', padding: '1.2vw 0vw', borderBottom: '1px solid lightgray', marginTop: '1vh' }}
                            >
                                <div className="request-content">
                                    <div className="request-info">
                                        <p style={{ marginBottom: '.2vw' }}>
                                            <b>Request Name :</b> {item.requestName}
                                        </p>
                                    </div>
                                    <div className="right-section">
                                        <div style={{ textAlign: 'left' }}>
                                            <div><b>SR :</b> {item.caseNumber}</div>
                                            <div style={{ marginTop: '.1vh' }}><b>Status :</b> {item.requestStatus ? item.requestStatus : 'NA'}</div>
                                            {
                                                (item.Comments != null && item.Comments != "" && item.Comments != " ") &&
                                                <>
                                                    <button
                                                        onClick={() => handleToggleClose(1, item)}
                                                        id='servicerequestsubmitbutton'
                                                        style={{ backgroundColor: 'Transparent', color: 'rgb(155,19,74)', marginTop:'1vh' }}
                                                    >
                                                        View Details
                                                    </button>
                                                </>
                                            }
                                        </div>
                                        <div>
                                            <p>
                                                {new Date(item.createDate).toLocaleDateString('en-GB', {
                                                    day: 'numeric',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })}
                                            </p>
                                            {item.documentURL !== null && item.documentURL !== "" && (
                                                <div className="button-container">
                                                    <button
                                                        className="view-button"
                                                        onClick={() => handleViewDocument(item.documentURL)}
                                                    >
                                                        VIEW
                                                    </button>
                                                    <button
                                                        className="download-button"
                                                        onClick={() => handleDownloadDocument(item.documentURL)}
                                                    >
                                                        DOWNLOAD
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* Document Viewer Popup */}
                        {showPopup && (
                            <div
                                className="modal-overlay"
                                onClick={closePopup}
                            >
                                <div
                                    className="modal-content"
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}
                                >
                                    {/* Header */}
                                    <div className="modal-header">
                                        <button
                                            onClick={closePopup}
                                            className="close-button"
                                        >
                                            ✕
                                        </button>
                                    </div>

                                    {/* Document Content */}
                                    <div className="modal-body" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                                        <iframe
                                            src={currentDocURL}
                                            className="document-iframe"
                                            title="Document Viewer"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1vw' }}>
                        {currentItems.length > 0 && <button onClick={handlePrev} disabled={currentPage === 1} className='servicerequestpaginationbutton' style={{ marginLeft: '1vw', color: currentPage === 1 ? 'lightgray' : theme.palette.primary.main, }}>Previous</button>}

                        {Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentPage(index + 1)}
                                style={{
                                    margin: '0 0.5vw',
                                    backgroundColor: currentPage === index + 1 ? 'rgb(155,19,74)' : 'transparent',
                                    borderRadius: '50%',
                                    height: '23px',
                                    width: '23px',
                                    border: 'none',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    color: currentPage === index + 1 ? 'white' : theme.palette.primary.main,
                                }}
                            >
                                {index + 1}
                            </button>
                        ))}
                        {currentItems.length > 0 && <button onClick={handleNext} disabled={currentPage === totalPages} className='servicerequestpaginationbutton' style={{ marginLeft: '1vw', color: currentPage === totalPages ? 'lightgray' : theme.palette.primary.main, }} >Next</button>}

                    </div>
                </div>
            </>

        );
    }
};

export default ServiceStatus;